import BibleBook from './BibleBook';
import BibleVerse from './BibleVerse';

export default class BibleChapter {

    private verses = new Map<number, BibleVerse>();

    constructor(private readonly index: number, private readonly chapterNumber: number,
        private readonly name: string, private readonly shortName: string, private readonly book: BibleBook) {
    }

    public getIndex(): number {
        return this.index;
    }

    public getNumber(): number {
        return this.chapterNumber;
    }

    public getName(): string {
        return this.name;
    }

    public getShortName(): string {
        return this.shortName;
    }

    public getBook(): BibleBook {
        return this.book;
    }

    public getVerseCount(): number {
        return this.verses.size;
    }

    public getVerses(): BibleVerse[] {
        return Array.from(this.verses.values());
    }

    public getVerse(verseNumber: number): BibleVerse {
        const verse = this.verses.get(verseNumber);
        if (verse === undefined) {
            throw new Error('Verse not found');
        }
        return verse;
    }

    public getOrSetVerse(index: number, verseNumber: number, name: string, shortName: string): BibleVerse {
        let verse = this.verses.get(verseNumber);
        if (verse === undefined) {
            verse = new BibleVerse(index, verseNumber, name, shortName, this.book, this);
            this.verses.set(verseNumber, verse);
        }
        return verse;
    }
}
